// react-router-dom components
import { Link } from 'react-router-dom';

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types';

// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import SocialMedia from 'csdd_components/SocialMedia';

function DefaultFooter({ content }) {
  const { brand, menus, copyright } = content;

  return (
    <MKBox bgColor='#800500' opacity={0.98} component='footer' pt={5}>
      <Container>
        <Grid container spacing={3} justifyContent='start' alignItems='start'>
          <Grid item xs={12} md={3}>
            <MKBox>
              <Link to={brand.route}>
                <MKBox
                  component='img'
                  src={brand.image}
                  alt={brand.name}
                  maxWidth='5rem'
                  style={{
                    borderRadius: '5px',
                  }}
                  mb={2}
                />
              </Link>
              <MKTypography fontWeight='regular' color='light' variant='h6'>
                {brand.name}
              </MKTypography>
            </MKBox>
            <SocialMedia spacing={2} marginTop={2} />
          </Grid>
          {menus.map(({ name: title, items }) => (
            <Grid key={title} item xs={12} md={2} mx='auto'>
              <MKTypography
                display='block'
                variant='body2'
                fontWeight='regular'
                color='light'
                textTransform='capitalize'
                mb={1}
              >
                {title}
              </MKTypography>
              <MKBox component='ul' p={0} m={0} sx={{ listStyle: 'none' }}>
                {items.map(({ name, route, href }) => (
                  <MKBox
                    key={name}
                    component='li'
                    p={0}
                    m={0}
                    lineHeight={1.25}
                    mb={1.5}
                  >
                    {href ? (
                      <MKTypography
                        component='a'
                        href={href}
                        target='_blank'
                        rel='noreferrer'
                        color='warning'
                        variant='button'
                        textTransform='capitalize'
                        fontWeight='regular'
                      >
                        {name}
                      </MKTypography>
                    ) : (
                      <MKTypography
                        component={Link}
                        to={route}
                        color='warning'
                        variant='button'
                        textTransform='capitalize'
                        fontWeight='regular'
                      >
                        {name}
                      </MKTypography>
                    )}
                  </MKBox>
                ))}
              </MKBox>
            </Grid>
          ))}
          <Grid item xs={12} sx={{ textAlign: 'center', mb: 1 }}>
            {copyright}
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {
  content: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.array])
  ).isRequired,
};

export default DefaultFooter;
